import { connect } from 'react-redux';
import withRouter from 'react-router/lib/withRouter';
import compose from 'recompose/compose';
import ProductItem from '../components/ProductItem';
import * as categoriesSelectors from '../../../../products/categories/selectors';

export default compose(
  withRouter,
  connect((state, ownProps) => ({
    category: categoriesSelectors.byId(state, ownProps.product.productCategoryId),
  })),
)(ProductItem);
